module.exports = __webpack_public_path__ + "static/ga-logo-hd-fb3b5ca01fa7ab57e682d8642d1445e7.png";